// BrandLockup.jsx
// Drop-in replacement for the old red "Simple Expense Management" pill.
// Renders the SEM icon + product title + "by freeAInow" endorsement.
//
// Usage in App.jsx — swap your current pill element for:
//   <BrandLockup />
// Keep your existing scans-chip / theme / logout controls next to it.

export default function BrandLockup() {
  return (
    <div className="sem-brand">
      <span className="sem-tile" aria-hidden="true">SEM</span>
      <span className="sem-brand-text">
        <span className="sem-title">Simple Expense Management</span>
        <span className="sem-by">
          by{" "}
          <span className="sem-mark">
            <span>free</span><b>AI</b><span>now</span>
          </span>
        </span>
      </span>
    </div>
  );
}
